import { Menu, UnstyledButton, Group, Text, Box } from "@mantine/core";
import { IconPalette, IconChevronDown } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { useAppearance } from "../theme/AppearanceContext";
import { APP_THEMES } from "../theme/themes";
import { THEME_IDS } from "../theme/prefs";

export function ThemeSwitcher({ compact = false, compactOnPhone = false }: { compact?: boolean; /** Icon-only, 40px target below `xs`. */ compactOnPhone?: boolean }) {
  const { t } = useTranslation();
  const { theme, setTheme } = useAppearance();

  return (
    <Menu shadow="md" position="bottom-end" withinPortal>
      <Menu.Target>
        <UnstyledButton
          className={compactOnPhone ? "app-switch-phone" : undefined}
          aria-label={t("appearance.theme")}
          style={{
            padding: "4px 8px",
            borderRadius: 6,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <IconPalette size={16} />
          {!compact && (
            <Text size="sm" visibleFrom="md">
              {t(`theme.${theme}`)}
            </Text>
          )}
          <IconChevronDown size={12} className={compactOnPhone ? "app-switch-chev" : undefined} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t("appearance.theme")}</Menu.Label>
        {THEME_IDS.map((id) => {
          const sw = APP_THEMES[id].swatch;
          return (
            <Menu.Item key={id} onClick={() => setTheme(id)} disabled={id === theme}>
              <Group gap="xs" wrap="nowrap">
                <Box
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: sw.bg,
                    border: "1px solid rgba(128,128,128,.4)",
                    display: "grid",
                    placeItems: "center",
                  }}
                >
                  <Box style={{ width: 8, height: 8, borderRadius: "50%", background: sw.accent }} />
                </Box>
                <Text size="sm" fw={id === theme ? 600 : 400}>
                  {t(`theme.${id}`)}
                </Text>
              </Group>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
